import React from 'react';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';

import useIntersection from 'hooks/useIntersection';
import './styles.scss';
import 'styles/common/_swiper-controls.scss';

SwiperCore.use(Navigation, Pagination);

const SwiperContainer = ({ testimonials }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.9,
  });

  return (
    <div className="cr-testimonials-swiper" ref={scrollWrapper}>
      <div
        className={classnames(
          'cr-testimonials-swiper__inner cr-swiper-controls-pagination cr-swiper-controls-navigation',
          { 'js-anim-init': inViewSec }
        )}
        ref={inViewRefSec}
      >
        <Swiper navigation pagination slidesPerView={1} loop="true">
          {testimonials.map((slide, i) => (
            <SwiperSlide key={i}>
              <div className="cr-slide-item">
                <p className="cr-slide-item__text cr-lead-2">
                  {slide.slideItemText}
                </p>

                <p className="cr-slide-item__info">
                  <span className={'cr-slide-item__info-author cr-h5 cr-main'}>
                    {slide.slideItemInfoAuthor}
                  </span>
                  <span
                    className={
                      'cr-slide-item__info-position cr-reg cr-text-2 cr-opacity-05'
                    }
                  >
                    {slide.slideItemInfoInfo}
                  </span>
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SwiperContainer;
